import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Growl } from 'primereact/growl';
import servicioArchivos from '../servicios/ServicioArchivos';

export class ComparacionPagosTelepeaje extends Component {
    constructor() {
        super();
    }

    onDrop = (files) => {
        let formData = new FormData();
        formData.append('layout', files[0]);
        servicioArchivos.descargaArchivo('/detalle_layout_telepeaje/comparacion_pagos.json',formData,this);
    }

    render() {

        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />               
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-col-8"><h2>Comparación pagos Layout Telepeaje</h2></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid">
                                <h3>Arrastra o da click en el recuadro rojo para agregar archivos</h3>
                                <div className="p-col-12  p-md-12">
                                    <Dropzone accept=".xlsx" onDrop={this.onDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section className="container">
                                                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                                    <input   {...getInputProps()} />
                                                    <center><p>Arrastra y suelta aquí los archivos .xlsx para validarlos</p></center>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}